import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack, Step, StepLabel, Stepper,
    TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import HeaderService from "../../../../../API/orders/orders/organization/HeaderService";
import ModelsUtil from "../../../../../utils/orders/ModelUtils";
import {Link, useNavigate} from "react-router-dom";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import CellCheckboxWithUnable from "../../../сheckbox/CellCheckboxWithUnable";
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import BasicModelService from "../../../../../API/model-estimate/model/BasicModelService";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import {replaceEmptyStringsOnNull} from "../../../../../utils/ReplaceEmptyStringsOnNull";
import ButtonBack from "../../../button/ButtonBack";
import PackagingSetService from "../../../../../API/model-estimate/packaging/PackagingSetService";
import PackagingSetTable from "../packaging/PackagingSetTable";

const steps = [
    'Наименования',
    'Упаковка',
];
const BasicModelsTable = ({
                              setBasicModelId,
                              setModalModelsOpen,
                              modal,
                              data,
                              setData,
                              unable,
                              setUnable,
                              change,
                              setChange,
                              tableOptions,
                              tableOptionsHandle,
                              selectId,
                              select,
                              handleModalAlert
                          }) => {
        const [createModalOpen, setCreateModalOpen] = useState(false);
        const [updateModalOpen, setUpdateModalOpen] = useState(false);
        const [modelHeaderList, setModelHeaderList] = useState([]);
        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentEditRowId, setCurrentEditRowId] = useState(null);

        const handleCreateNewRow = (values) => {
            setData([...data, values]);
            unable[values.id] = values.enabled;
            tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
        };

        const handleUpdate = (values) => {
            setData(prev => prev.map(el => el.id === values.id ? values : el));
        };

        const openModels = useCallback(
            (row) => {
                setBasicModelId(row.id)
                setModalModelsOpen(true);
            },
            [data],
        );


        const handleDeleteRow = useCallback(
            (row) => {
                BasicModelService.delete(row.id)
                    .then(function () {
                        setData(prev => prev.filter(el => el.id !== row.id))
                        tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                        handleModalAlert("Данные удалены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
            },
            [data],
        );

        const handleUpdateModel = useCallback(
            (row) => {
                setCurrentEditRowData(row);
                setCurrentEditRowId(row?.id);
                setUpdateModalOpen(true);

            },
            [data, currentEditRowData, setCurrentEditRowData],
        );

        const handleUnableCheckbox = (id, status) => {
            BasicModelService.unable(id, status)
                .then(function () {
                    handleUnable(id, status)
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        };

        const handleUnable = (id, status) => {
            unable[id] = status
            setUnable(prevState => ({
                ...prevState,
                [id]: status
            }));
        };

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'name',
                    header: 'Модель',
                    accessorKey: 'name',
                    minSize: 350,
                    Cell: ({cell, row}) => {
                        return (
                            !modal ? <li key={cell.getValue()}>
                                <Link
                                    to={'/organization/basic-models/' + row.original.id + '/estimates'
                                    }>{cell.getValue() === undefined ? 'Не определено' : cell.getValue()}</Link>
                            </li> : cell.getValue() === undefined ? 'Не определено' : cell.getValue()
                        )
                    }
                },
                {
                    id: 'headerName',
                    header: 'Наименование',
                    accessorKey: 'headerName',
                    filterVariant: 'multi-select',
                    filterSelectOptions: modelHeaderList,
                    minSize: 30,
                },
                {
                    header: 'id',
                    id: 'id',
                    accessorKey: 'id',
                    enableHiding: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                },
            ];

            if (!modal) {
                baseColumns.splice(7, 0, {
                    header: 'Статус',
                    accessorKey: 'enabled',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckboxWithUnable
                        id={row.original.id}
                        unable={unable}
                        setUnable={handleUnableCheckbox}
                    >
                    </CellCheckboxWithUnable>,
                });
            }

            if (!modal) {
                baseColumns.splice(8, 0, {
                    id: 'packagingSet.articleNumber',
                    header: 'Артикул упаковки',
                    accessorKey: 'packagingSet.articleNumber',
                    minSize: 15,
                    maxSize: 15,
                    enableEditing: false,
                    Cell: ({cell, row}) => {
                        if (data[row.index].packagingSet !== null) {
                            return (
                                <li key={cell.getValue()}>
                                    <Link
                                        to={'/organization/packaging-sets/' + data[row.index].packagingSet.id + '/' + encodeURIComponent(data[row.index].packagingSet.articleNumber)
                                        }>{cell.getValue() === undefined ? 'Не определено' : cell.getValue()}</Link>
                                </li>
                            );
                        } else {
                            return (
                                <li key={cell.getValue()}>
                                    {cell.getValue() === undefined ? 'Не определено' : cell.getValue()}
                                </li>
                            );
                        }
                    }
                });
            }

            return baseColumns;

        }, [data, setData,]);

        const menuItem = modal ? [
            {type: "delete", text: "Показать модели", handler: openModels},
        ] : [
            {type: "edit", text: "Редактировать", handler: handleUpdateModel},
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
        ]
        return (
            <Box
                sx={{
                    overflow: 'auto',
                    maxWidth: modal ? "100vw" : 'calc(100vw - 410px)',
                }}
            >
                <Box
                    sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
                >
                    {!modal && <ButtonCreate
                        text={"Создать модель"}
                        width={180}
                        onClick={() => setCreateModalOpen(true)}
                    />}
                </Box>

                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            width: '1000px',
                            maxHeight: `calc(100vh - 420px)`
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:first-of-type": !modal && {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },
                            "& li": {
                                listStyleType: "none",
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }
                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            onClick: () => select && select(row.original),
                            sx: () => ({
                                height: '36px',
                                cursor: select && "pointer",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light : "white",
                                "&:hover": {
                                    backgroundColor: row.original.id === selectId ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                            })
                        })
                    }}

                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    columns={columns}
                    data={data}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        sorting: [{id: 'name', desc: false}],
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                    }}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    rowCount={tableOptions.totalElements}
                    enableRowActions={!modal}
                    enableToolbarInternalActions={false}
                    getRowId={(originalRow) => originalRow.id}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })
                    }
                    localization={MRT_Localization_RU}
                />
                {!modal && <CreateNewModelModal
                    columns={columns}
                    open={createModalOpen}
                    onClose={() => setCreateModalOpen(false)}
                    onSubmit={handleCreateNewRow}
                    handleModalAlert={handleModalAlert}
                />}
                {!modal && <UpdateModelModal
                    columns={columns}
                    open={updateModalOpen}
                    onClose={() => setUpdateModalOpen(false)}
                    onSubmit={handleUpdate}
                    values={currentEditRowData}
                    currentEditRowId={currentEditRowId}
                    change={change}
                    setChange={setChange}
                    handleModalAlert={handleModalAlert}
                />}
            </Box>
        );
    }
;

export const CreateNewModelModal = ({open, columns, onClose, onSubmit, handleModalAlert}) => {
    const [modelHeaderList, setModelHeaderList] = useState([]);
    const [values, setValues] = useState({
        headerId: modelHeaderList[0]?.id,
        headerName: modelHeaderList[0]?.name,
        "name": "",
    })
    const [selectedString, setSelectedString] = useState(null)
    const [activeStep, setActiveStep] = useState(0)
    const [data, setData] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        HeaderService.getAllUnableForModels().then(function (response) {
            setModelHeaderList(response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
        PackagingSetService.getAll().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);


    const handleSubmit = () => {
        setLoading(true)
        const data = {
            headerId: values.headerId || modelHeaderList[0]?.id,
            headerName: values.headerName || modelHeaderList[0]?.name,
            "name": values.name, enabled: true,
            packagingSet: selectedString
        }
        BasicModelService.save(replaceEmptyStringsOnNull(data), data.headerId).then(function (response) {
            onSubmit(response.data);
            close()
            handleModalAlert("Данные добавлены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    };
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }
    const close = () => {
        setActiveStep(0)
        setValues({
            headerId: modelHeaderList[0]?.id,
            headerName: modelHeaderList[0]?.name,
            "name": "",
        })
        setSelectedString(null)
        onClose()
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "500px" : "900px"}`,
                height: activeStep === 0 ? "410px" : `calc(100vh - 420px)`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>Создать модель</DialogTitle>
                {<Stepper
                    style={{width: 446}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <DialogContent>
                {activeStep === 0 ? <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                            gap: '0.01rem',
                        }}
                    >
                        <TextField
                            size={"small"}
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '0.01rem',
                            }}
                            margin="normal"
                            id="modelHeader"
                            select
                            label="Наименование"
                            value={[values.headerName, values.headerId]}
                            onChange={(e) => {
                                const [headerName, headerId] = e.target.value.split(",");
                                setValues({...values, headerId: headerId, headerName: headerName})
                            }}
                            SelectProps={{
                                native: true,
                            }}
                        >
                            {modelHeaderList.map((modelHeader) => (
                                <option
                                    key={modelHeader.id}
                                    value={[modelHeader.name, modelHeader.id]}
                                >
                                    {modelHeader.name}
                                </option>
                            ))}
                        </TextField>

                        <TextField
                            size={"small"}
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '0.01rem',
                            }}
                            margin="normal"
                            key={"name"}
                            label={"Модель"}
                            name={"name"}
                            onChange={(e) =>
                                setValues({...values, name: e.target.value})
                            }
                        />
                    </Stack>
                    : <Box> <PackagingSetTable
                        handleModalAlert={handleModalAlert}
                        data={data}
                        setData={setData}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        isModal={true}
                        selectedStringId={selectedString?.id}
                        setSelectedString={setSelectedString}/>
                    </Box>}
            </DialogContent>
            <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 &&
                    <ButtonBack text={"Выйти"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Отменить"} onClick={close}/>
                    <ButtonAdd
                        loading={loading}
                        text={activeStep === 0 ? "Выбрать" : "Сохранить"}
                        onClick={activeStep === 0 ? () => setActiveStep(1) : handleSubmit}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export const UpdateModelModal = ({open, columns, onClose, onSubmit, values, change, setChange, handleModalAlert}) => {
    const [modelHeaderList, setModelHeaderList] = useState([]);
    const [modelHeaderId, setModelHeaderId] = useState(null);
    const [selectedString, setSelectedString] = useState(null)
    const [activeStep, setActiveStep] = useState(0)
    const [data, setData] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    useEffect(() => {
        HeaderService.getAllUnableForModels().then(function (response) {
            setModelHeaderList(response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
        PackagingSetService.getAll().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    useEffect(() => {
        setSelectedString(values?.packagingSet)
    }, [values]);


    const handleSubmit = () => {
        setLoading(true)
        BasicModelService.update(replaceEmptyStringsOnNull({
            ...values, packagingSet: selectedString
        }), modelHeaderId === null ? values.headerId : modelHeaderId).then(function (response) {
            onSubmit(response.data);
            setModelHeaderId(null)
            close()
            if (modelHeaderId !== null) {
                setChange(!change)
            }
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    };
    const close = () => {
        setActiveStep(0)
        setSelectedString(null)
        onClose()
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "500px" : "900px"}`,
                height: activeStep === 0 ? "410px" : `calc(100vh - 420px)`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>Редактировать модель</DialogTitle>
                {<Stepper
                    style={{width: 446}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <DialogContent>
                {activeStep === 0 ? columns.map((column) => (
                        ModelsUtil.checkCreateField(column) &&
                        <TextField
                            size={"small"}
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '0.01rem',
                            }}
                            margin="normal"
                            key={column.accessorKey}
                            label={column.header}
                            name={column.accessorKey}
                            defaultValue={values === null ? "" : values[column.accessorKey]}
                            onChange={(e) =>
                                values[column.accessorKey] = e.target.value
                            }
                        />
                    ))
                    : <Box> <PackagingSetTable
                        handleModalAlert={handleModalAlert}
                        data={data}
                        setData={setData}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        isModal={true}
                        selectedStringId={selectedString?.id}
                        setSelectedString={setSelectedString}/>
                    </Box>}
            </DialogContent>
            <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 &&
                    <ButtonBack text={"Выйти"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Отменить"} onClick={close}/>
                    <ButtonAdd
                        loading={loading}
                        text={activeStep === 0 ? "Выбрать" : "Сохранить"}
                        onClick={activeStep === 0 ? () => setActiveStep(1) : handleSubmit}
                    />
                </Box>
            </DialogActions>
        </Dialog>

    );
};

export default BasicModelsTable;